export default __webpack_public_path__ + "static/media/investment-white.421ada7e.svg";